import React from 'react'
import PropTypes from 'prop-types'
import EasyPieChart from 'easy-pie-chart'

const propTypes = {
  percentage: PropTypes.number.isRequired,
}

class PieChart extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      chart: undefined,
    }
  }

  componentDidMount() {
    const element = document.querySelector(`#chart-progress-${this.props.id}`)
    this.state.chart = new EasyPieChart(element, {
      animate: {
        duration: 800,
        enabled: true,
      },
      barColor: '#1e87f0',
      trackColor: 'rgba(200,200,200,0.4)',
      scaleColor: false,
      lineWidth: 15,
      lineCap: 'round',
      size: 145,
    }).update(this.props.percentage)
  }

  render() {
    if (this.state.chart) {
      this.state.chart.update(this.props.percentage)
    }

    return (
      <div
        className="uk-text-center"
        style={{
          width: 150,
          marginLeft: 'auto',
          marginRight: 'auto',
          left: 0,
          right: 0,
        }}
      >
        <div style={{ position: 'relative' }}>
          <div
            id={`chart-progress-${this.props.id}`}
            data-percentage={this.props.percentage}
          />
          <div
            style={{
              position: 'absolute',
              top: 50,
              marginLeft: 'auto',
              marginRight: 'auto',
              left: 0,
              right: 0,
            }}
          >
            <h1 className="uk-margin-remove uk-text-bold">{this.props.percentage}</h1>
          </div>
        </div>
      </div>
    )
  }
}

PieChart.propTypes = propTypes

export default PieChart
